import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import api from '../services/api';

export const useSuppliers = () => {
    return useQuery({
        queryKey: ['suppliers'],
        queryFn: api.suppliers,
    });
};

export const useSupplier = (uid) => {
    return useQuery({
        queryKey: ['suppliers', uid],
        queryFn: () => api.getSupplier(uid),
        enabled: !!uid,
    });
};

export const useCreateSupplier = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: (data) => api.createSupplier(data),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['suppliers'] });
        },
    });
};

export const useUpdateSupplier = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: ({ uid, data }) => api.updateSupplier(uid, data),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['suppliers'] });
        },
    });
};

export const useDeleteSupplier = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: (uid) => api.deleteSupplier(uid),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['suppliers'] });
        },
    });
};
